import { useContext } from "react";
import { AppContext } from "../AppContextProvider/AppContext";
import { AppContextType } from "../AppContextProvider/type";

export function useAppContext() {
  return useContext(AppContext) as AppContextType;
}
